export default "__VITE_ASSET__taBn9ajs__"